var map = {
	"./about-min.svg": 1513,
	"./docs-min.svg": 9183,
	"./export-min.svg": 7050,
	"./import-min.svg": 9302,
	"./intro-min.svg": 4904,
	"./legal-info-min.svg": 2332,
	"./main-min.svg": 4394,
	"./members-min.svg": 4172,
	"./organization-min.svg": 3413,
	"./other-min.svg": 1686,
	"./production-min.svg": 9744,
	"./retail-min.svg": 5697,
	"./rules-min.svg": 8247,
	"./violation-min.svg": 1220,
	"./warning-min.svg": 7616,
	"./wholesale-min.svg": 6134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8364;